import TaskRecord from './TaskRecord';

class ClockDrawingTaskRecord extends TaskRecord {

    constructor() {
        super()
        this.taskType = 'ClockDrawing'
        this.drawings = null
    }

    parseLogExtra(logJson) {
        if (!logJson) return
        this.drawings = logJson['Drawings']
    }

    //--
}

export default ClockDrawingTaskRecord;